<!--suppress JSUnresolvedVariable -->
<template>
  <div class="my-4 mx-1">
    <el-row>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/admin/dashboard' }"
          >管理中心
        </el-breadcrumb-item>
        <el-breadcrumb-item>文章内容</el-breadcrumb-item>
        <el-breadcrumb-item
          ><span class="text-primary">招聘管理</span></el-breadcrumb-item
        >
      </el-breadcrumb>
    </el-row>
    <el-card class="my-3 mx-1">
      <div slot="header">
        <el-button
          @click="addJob(0)"
          size="small"
          type="primary"
          plain
          :disabled="!adminPermissions.includes('/job/admin/addOrUpdateJob')"
        >
          新增职位
        </el-button>
      </div>
      <el-table
        ref="multipleTable"
        :data="jobList"
        tooltip-effect="dark"
        style="width: 100%;"
        height="417"
        stripe
        v-loading="loading"
        element-loading-text="拼命加载中"
      >
        <el-table-column
          prop="jobId"
          label="职位ID"
          sortable
          align="center"
          width="120"
        >
        </el-table-column>
        <el-table-column prop="jobName" label="职位名称" align="center">
        </el-table-column>
        <el-table-column prop="jobViews" sortable label="访问量" align="center">
        </el-table-column>
        <el-table-column label="状态" align="center" width="170">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.jobStatus"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="已发布"
              inactive-text="未发布"
              :disabled="
                !adminPermissions.includes('/job/admin/addOrUpdateJob')
              "
              @change="value => jobStatusChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="首页显示" align="center" width="138">
          <template slot-scope="scope">
            <el-switch
              v-model="scope.row.homeShow"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-text="是"
              inactive-text="否"
              :disabled="
                !adminPermissions.includes('/job/admin/addOrUpdateJob')
              "
              @change="value => isHomeShowChange(value, scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
          prop="publishTime"
          sortable
          label="发布时间"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right" width="200">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="keywordSearch"
              size="mini"
              placeholder="输入关键字,按回车开始搜索"
              @keyup.enter.native="startSearch(scope)"
            />
          </template>
          <template slot-scope="scope">
            <el-button
              @click="editJobInfo(scope.row.jobId)"
              type="primary"
              plain
              size="small"
              :disabled="
                !adminPermissions.includes('/job/admin/addOrUpdateJob')
              "
              >编辑
            </el-button>
            <el-button
              type="danger"
              slot="reference"
              plain
              @click="deleteJobById(scope.row.jobId)"
              size="small"
              :disabled="!adminPermissions.includes('/job/admin/deleteJob')"
            >
              移除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="pt-3"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </el-card>
  </div>
</template>

<!--suppress JSUnusedGlobalSymbols -->
<script>
export default {
  name: "JobList",
  data() {
    return {
      jobList: [],
      adminPermissions: this.$store.state.adminPermissions,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      total: 0,
      keywordSearch: ""
    };
  },
  mounted() {
    this.getJobList();
  },
  methods: {
    getJobList() {
      this.loading = true;
      this.axios
        .get("/job/admin/getJobList", {
          params: {
            currentPage: this.currentPage,
            pageSize: this.pageSize
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getJobList();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getJobList();
    },
    startSearch() {
      this.loading = true;
      this.axios
        .get("/job/getJobByKeyword", {
          params: {
            currentPage: 1,
            pageSize: this.pageSize,
            keyword: this.keywordSearch
          }
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            this.jobList = resp.data.data.records;
            this.total = resp.data.data.total;
            this.loading = false;
          }
        });
    },
    jobStatusChange(status, job) {
      this.axios
        .post("/job/admin/addOrUpdateJob", {
          jobId: job.jobId,
          jobStatus: status,
          homeShow: job.homeShow
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (status) {
              this.$notify({
                title: "成功",
                message: "职位发布成功",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "职位撤销成功",
                type: "success"
              });
            }
          }
        });
    },
    isHomeShowChange(value, job) {
      this.axios
        .post("/job/homeShowChange", {
          jobId: job.jobId,
          jobStatus: job.jobStatus,
          homeShow: value
        })
        .then(resp => {
          if (resp && resp.data.code === 10000 && resp.data.success) {
            if (value) {
              this.$notify({
                title: "成功",
                message: "已设置为首页显示",
                type: "success"
              });
            } else {
              this.$notify({
                title: "成功",
                message: "已取消首页显示",
                type: "success"
              });
            }
          }
        });
    },
    editJobInfo(jobId) {
      this.$router.push({ name: "JobForm", params: { jobId: jobId } }).catch();
    },
    addJob(jobId) {
      this.$router.push({ name: "JobForm", params: { jobId: jobId } }).catch();
    },
    deleteJobById(jobId) {
      this.$confirm("此操作将永久删除该职位, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.axios
            .delete("/job/admin/deleteJob", {
              params: {
                jobId: jobId
              }
            })
            .then(resp => {
              if (resp && resp.data.code === 10000 && resp.data.success) {
                this.getJobList();
                this.$message({
                  type: "success",
                  message: "删除成功!"
                });
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    }
  }
};
</script>

<style scoped></style>
